import { useEffect, useRef, useState } from 'react';

// Which pane the picker shows: the Reels, the progress while a mapping runs, or the mapped
// personality. It opens on the personality when there is one, and on the Reels when there is
// none yet or the latest mapping failed (the choice starts from it). A mapping that settles
// while the dialog is open moves it: to the personality when it completes, back to the Reels
// (with what failed) when it fails. A failure from before the dialog opened also shows, until
// dismissed or replaced by a new mapping.
export default function usePersonalityView(myPersonality) {
  const { running, mapping, personality, retry } = myPersonality;
  const [view, setView] = useState(running ? 'progress' : personality && !retry ? 'personality' : 'reels');
  const [mapped, setMapped] = useState(false);
  const [dismissed, setDismissed] = useState(null);
  const wasRunning = useRef(running);
  useEffect(() => {
    if (running) { setView('progress'); setMapped(false); }
    else if (wasRunning.current) {
      const completed = mapping?.status === 'completed';
      setMapped(completed);
      setView(completed ? 'personality' : 'reels');
    }
    wasRunning.current = running;
  }, [running]); // eslint-disable-line react-hooks/exhaustive-deps
  const failure = mapping?.status === 'failed' && dismissed !== mapping.id ? mapping : null;
  return { view: running ? 'progress' : view, setView, mapped, failure, dismiss: () => setDismissed(mapping?.id || null) };
}
